<app-loader></app-loader>
<app-navigation *ngIf="showNavFooter"></app-navigation>
<router-outlet></router-outlet>
<app-footer *ngIf="showNavFooter"></app-footer>
<app-toast-container></app-toast-container>